import { render, staticRenderFns } from "./confirmation-button.vue?vue&type=template&id=b991abb0&scoped=true&"
import script from "./confirmation-button.vue?vue&type=script&lang=js&"
export * from "./confirmation-button.vue?vue&type=script&lang=js&"
import style0 from "./confirmation-button.vue?vue&type=style&index=0&id=b991abb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b991abb0",
  null
  
)

export default component.exports